import React from 'react'
import { Link } from 'react-router-dom'
import galleryimg from'../Assets/Images/galleryimg.jpg'
import { SlideshowLightbox } from 'lightbox.js-react'
const SubGallery = () => {
  return (
     <>
     <div className="innerslide">
     <ul className="breadcrumb">
          <li><Link to="/"> Home</Link> </li>
          <li>  Gallery</li>
          <li>  Photo Gallery </li>
          <li>Sub Gallery</li>
    </ul>
</div>
<div className="innersec">
 <div className="container">
       <div className="row">
         <div className="col-lg-12">
               <h1>  Sub Gallery </h1>
          </div>
       </div>
              <div className="row tabs-dynamic">
          <div className="col-md-6 col-xl-3">
              <div className="count-val">
                  <p><Link to="/PhotoGallery"><i className="bi bi-arrow-left"></i> Go Back</Link>  </p>
              </div>
          </div>
          <div className="col-md-6 col-xl-3">
              <div className="month-selection">
                  <p><span>Event Date:</span> 16 Feb 2023</p>
              </div>
          </div>
          <div className="col-md-6 col-xl-3">
              <div className="month-selection">
                  <p><span>Last Update:</span> 16 Feb 2023</p>
              </div>
          </div>
          <div className="col-md-6 col-xl-3">
              <div className="searchBox">
                  <p><span>No. Of Photos:</span> 27</p>
              </div>
          </div>
      </div>
        <div className="row">
          <div className="col-md-12">
              <h4 className="gallery-title">Sub Gallery Title</h4>
              <p>Stay Tunned For More Updates ! Stay Tunned For More Updates !  Stay Tunned For More Updates ! </p>
          </div>
         <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
              <div className="gallery-block">
                  <div className="backDiv"></div>
                  <SlideshowLightbox><img src={galleryimg} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                  
              </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
              <div className="gallery-block">
                  <div className="backDiv"></div>
                  <SlideshowLightbox><img src={galleryimg} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                  
              </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
              <div className="gallery-block">
                  <div className="backDiv"></div>
                  <SlideshowLightbox><img src={galleryimg} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                  
              </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
              <div className="gallery-block">
                  <div className="backDiv"></div>
                  <SlideshowLightbox><img src={galleryimg} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                  
              </div>
          </div>
          <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4 col-xxl-3 galleryCount sub-gallerycount">
              <div className="gallery-block">
                  <div className="backDiv"></div>
                  <SlideshowLightbox><img src={galleryimg} className="img-fluid border-img w-full rounded" alt="Sacred Heart Convent School, Jagraon" /></SlideshowLightbox>
                  
              </div>
          </div>
          <div className="load-more">
              <div className="next">Show More</div>
          </div>
      </div> 
    </div>
  </div>
     </>
  )
}

export default SubGallery
